import React from 'react';
import SEO from '../components/SEO';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <SEO
        title="Disclaimer | Risk Disclosure | Equi Pulse Research"
        description="Important disclaimer and risk disclosure for Equi Pulse Research advisory services. Investment in securities market are subject to market risks."
        url="/disclaimer"
      />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-amber-400 mb-8">Disclaimer</h1>
        
        <div className="prose prose-invert prose-amber max-w-none text-gray-300">
          <p className="mb-8">
            <strong>Equi Pulse</strong> is a SEBI-registered Research Analyst (Registration No. INH000024046).
          </p>

          <p className="mb-8">
            We provide research reports, market commentary, and analytical views in accordance with the SEBI (Research Analyst) Regulations, 2014.
          </p>

          <p className="mb-8">
            All opinions, insights, and research published through our website, reports, emails, newsletters, videos, or social media are general in nature and must not be interpreted as personalized or guaranteed investment advice. We do not constitute personalized investment advice or portfolio management.
          </p>

          <p className="mb-8">
            All information, research, data, opinions, forecasts and market views expressed by Equi Pulse are derived from sources we believe to be reliable. However, we do not guarantee the accuracy, completeness, or reliability of any information provided, and we shall not be held responsible for any errors, omissions, or resulting losses. Market conditions may change without notice, and research views may be updated accordingly.
          </p>

          <div className="bg-amber-900/20 border border-amber-500/30 p-6 rounded-lg my-8">
            <h2 className="text-xl font-bold text-amber-400 mb-3">Important Risk Warnings</h2>
            <ul className="space-y-3">
              <li>Investing and trading in equities, commodities, derivatives, and financial securities involve substantial risks, including the risk of loss of capital.</li>
              <li>Past performance is not indicative, reflective, or a guarantee of future outcomes.</li>
              <li>No research report or analytical view should be interpreted as an assurance of returns or as a guarantee against losses.</li>
            </ul>
          </div>

          <p className="mb-8">
            Clients and users are solely responsible for evaluating their risk tolerance, personal financial situation, investment objectives, and for making their own investment decisions.
          </p>

          <p className="mb-8">
            Before acting on any suggestion or information, users should conduct independent due diligence and, it is advisable to consult a certified investment advisor or financial professional for personalized guidance. Equi Pulse shall not be liable for any investment decisions or losses arising from acting on our research or content.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Disclosure of Interest</h2>
          <p className="mb-8">
            Equi Pulse, its analysts or its representatives, may have positions in the securities discussed in our research reports. Such positions will be disclosed when required under SEBI regulations.
          </p>

          <p className="mb-8">
            We do not receive any commission, remuneration, or benefits from brokers, intermediaries, or third parties for recommending or promoting securities.
          </p>

          <p className="mb-8">
            We do not endorse, promote, or recommend any specific broker, issuer, or investment product. We maintain independence and objectivity in our research work.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Not Financial Advice</h2>
          <p className="mb-8">
            All communication from Equi Pulse—whether through website, reports, emails, messages, or videos—is not intended to be business, tax, accounting, or legal advice. Users must consult their own qualified professionals before making decisions based on such matters.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Official Communication</h2>
          <p className="mb-8">
            All official recommendations, updates, and investment-related instructions from Equi Pulse are provided only in writing through official channels. No verbal or telephonic communication should be treated as research guidance or official commentary.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Forward-Looking Statements</h2>
          <p className="mb-8">
            Certain sections of our research may contain forward-looking statements based on current market expectations. Due to uncertainties, unforeseen events and risks inherent in financial markets, actual outcomes may differ materially from those anticipated. Users should not rely solely on such statements for making decisions.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Proprietary Content</h2>
          <p className="mb-8">
            All content produced by Equi Pulse—including research reports, data, charts, newsletters, alerts, and analytical commentary—is proprietary. Reproduction, redistribution, forwarding, or unauthorized sharing of paid or free content is strictly prohibited, and violations may lead to legal action and termination of the services.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Third-Party Links</h2>
          <p className="mb-8">
            This website may contain links or references to third-party websites, tools, or advertisements. Equi Pulse does not verify, endorse, control, or take responsibility for any external content, data, or services.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">Jurisdiction</h2>
          <p className="mb-8">
            Equi Pulse does not assume responsibility for compliance with laws applicable in jurisdictions outside India.
          </p>

          <p className="mb-8">
            All disputes, claims, or legal matters arising out of the use of this website or our services shall be subject to the exclusive jurisdiction of the courts in Indore, Madhya Pradesh, India.
          </p>

          <div className="bg-slate-800/50 border border-amber-500/20 p-6 rounded-lg my-8">
            <h2 className="text-xl font-bold text-amber-400 mb-3">Final Declaration</h2>
            <p className="mb-4">
              By accessing this website or subscribing to our services, you acknowledge that you have read, understood, and agree to this Disclaimer and all related Terms & Conditions.
            </p>
            <p>
              Subscription fees are non-refundable, and no legal, financial, or other claims shall be made against Equi Pulse or its representatives for any investment outcomes resulting from reliance on our research.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPage;